import React from 'react'
import PropTypes, {oneOfType} from "prop-types"
import Component from "../../../../common/src/components/widget/Component";

class ValueLabel extends Component {
  render() {
    return (
      <div className={"info-card-wrapper"}>
        <div className={"info-card-text label"}>{this.props.label}:</div>
        <div className={"info-card-text"}>
          {this.props.isCheckbox ?
            (this.props.checked ?
              <span className={"icon fz fz-check has-text-success"}/> :
              <span className={"icon fz fz-times has-text-danger"}/>) :
            <span
              className={"info-card-text"}>{this.props.value}{this.props.unit ? this.props.unit : null}</span>}
        </div>
      </div>
    );
  }
}

ValueLabel.defaultProps = {
  isCheckbox: false,
  checked: false,
};

ValueLabel.propTypes = {
  id: PropTypes.string,
  value: oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  isCheckbox: PropTypes.bool,
  checked: PropTypes.bool,
  unit: PropTypes.string
};


export default ValueLabel
